import React from 'react';

const Advanced = ({API, organization, info}) => {

    return <iframe
        src={`${API}/calculator.html?calculation=${info
            ?.calculationID}&key=${info
                    ?.calculationKey}&organization=${organization}`}
        title="Avancerad"
        
        width="100%"
        style={{
        overflow: "show",
        height: "8000px",
        border: "none"
    }}/>;

};

export default Advanced;